import React, { useEffect, useState } from "react";
import {
  customSectionAPI,
} from "../../../public/constants/constants";
import apiManager from "../../utils/apiManager";
import "../../../public/styles/blog/socialIcons.scss";

function Social(props) {
  const [socialIcons, setSocialIcons] = useState([props.socialIcons]);
  const [customData, setCustomData] = useState("");
  const [instaLogo, setInstaLogo] = useState("");

  const getCustomImages = id => {
    apiManager
      .get(`${customSectionAPI  }${id}`)
      .then(response => {
        setCustomData(response.data.data[0].htmlcontent[0].value);
      })
      .catch(error => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    getCustomImages(props.homeImages.customSection.id);
    const logo = props.socialIcons.find(
      item => item.slug == "social-media-youtube"
    );
    setInstaLogo(logo);
  }, []);
  useEffect(
    () => {
      const logo = props.socialIcons.find(
        item => item.slug == "social-media-youtube"
      );
      setInstaLogo(logo);
    },
    [props]
  );

  return (
    <div className="social-icons-container">
      <div className="icons-row">
        <div className="content">
          Find all the inspiration you need to mix, match and make it yours.
        </div>
        <div className="icons">
          <div className="text">Follow us:</div>
          {props.socialIcons &&
            props.socialIcons.length && (
            <>
              {props.socialIcons.map(
                (item, index) =>
                  item && (
                    <div className="list" key={index}>
                      <a
                        className="link"
                        href={item.short_description}
                        target="_blank"
                      >
                        <img src={item.thumbnail} alt={item.title} />
                      </a>
                    </div>
                  )
              )}
            </>
          )}
        </div>
      </div>
      <div className="h-line" />
      {props.homeImages.customSection.displayFlag==1?
        <div
          className={`custom-section ${props.homeImages.customSection &&
          props.homeImages.customSection.short_description &&
          props.homeImages.customSection.short_description}`}
        >
          <div dangerouslySetInnerHTML={{ __html: customData }} />
          <div className="name-logo">
            {props.homeImages &&
            props.homeImages.customSection && (
              <span className="text">
                @godrejinterio on{" "}
                {props.homeImages.customSection.short_description}
              </span>
            )}
          </div>
        </div>
        :null
      }
    </div>
  );
}

export default Social;
